module.exports = __webpack_public_path__ + "img/Logo_white.f15514e7.png";